import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { addStaff, getstaffinfo, updateStaff } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";
import { Image } from "react-bootstrap";
import multi_img from "../images/multiple_docs.png";

const StaffDetails = ({ role, mainId, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [loading, setLoading] = useState(0);

  const [markRequired, setMarkRequired] = useState(true);

  const [photo, setPhoto] = useState(null);
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    setPhoto(file);
  };
  const [error, setErrors] = useState({});

  const [staffid, setStaffid] = useState("");

  const [staff, setStaff] = useState({
    name: "",
    father_name: "",
    post: "",
    date_of_birth: "",
    category: "",
    gender: "",
    doj: "",
    HRMS_id: "",
    phone_number: "",
    category_of_school: "",
    ddo: "",
    staff_aadhaar: "",
    staff_pan: "",
    highest_qualification: "",
    tenth_qualificationtenth_qualification: "",
    twelveth_qualification: "",
  });
  const location = useLocation();
  const rowData = location.state;
  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    // Set staff data from rowData when component mounts
    if (rowData) {
      setStaff((prevStaff) => ({
        ...prevStaff,
        ...rowData,
      }));
    }
  }, [rowData]);

  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      setStaff((student) => ({ ...student, [name]: value }));
    } else {
      const file = files[0];
      setStaff((student) => ({ ...student, [name]: file }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formErrors = {};
    const namePattern = /^[a-zA-Z\s'-\.]+$/;

    if (photo == null && !selectedRow.teacher_photo) {
      formErrors.photo_file = "No Staff photo selected!";
    }

    if (!staff.name.trim() && !selectedRow.teacher_name.trim()) {
      formErrors.name = "Staff Name is required";
    } else if (
      staff.name
        ? !namePattern.test(staff.name)
        : !namePattern.test(selectedRow.teacher_name)
    ) {
      formErrors.name = " Staff name must contain only letters";
    }

    if (!staff.father_name.trim() && !selectedRow.father_name.trim()) {
      formErrors.father_name = "Father's Name is required";
    } else if (
      staff.father_name
        ? !namePattern.test(staff.father_name)
        : !namePattern.test(selectedRow.father_name)
    ) {
      formErrors.father_name = "Father's Name must contain only letters";
    }

    if (!staff.post.trim() && !selectedRow.Category_of_post_held) {
      formErrors.post = "Post is required";
    } else if (
      staff.post
        ? !namePattern.test(staff.post)
        : !namePattern.test(selectedRow.Category_of_post_held)
    ) {
      formErrors.post = "Post must contain only letters";
    }

    if (!staff.gender && !selectedRow.Gender) {
      formErrors.gender = "Gender is required";
    }

    if (!staff.date_of_birth && !selectedRow.DOB) {
      formErrors.date_of_birth = "Date of Birth is required";
    }

    if (!staff.category && !selectedRow.Category) {
      formErrors.category = "Category is required";
    }

    if (!staff.doj && !selectedRow.Date_of_Joining_in_the_present_post) {
      formErrors.doj = "Date Of Joining is required";
    }

    if (!staff.HRMS_id && !selectedRow.HRMS_ID) {
      formErrors.HRMS_id = "HRMS ID is required";
    }

    if (!staff.phone_number && !selectedRow.teacher_contact_no) {
      formErrors.phone_number = "Phone Number is required";
    }

    if (!staff.ddo && !selectedRow.Name_of_DDO) {
      formErrors.ddo = "DDO is required";
    }

    if (!staff.category_of_school && !selectedRow.Category_of_school) {
      formErrors.category_of_school = "Category Of Schhol is required";
    }

    if (
      !staff.staff_aadhaar == null ||
      !staff.staff_pan == null ||
      !staff.student_aadhaar == null
    ) {
      toast.error("Documents upload pending!");
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);

      const formData = new FormData();

      formData.append("school_id", userData.data.school_id);
      formData.append("district_code", userData.data.district_code);
      formData.append(
        "teacher_name",
        staff.name ? staff.name : selectedRow.teacher_name
      );
      formData.append(
        "post",
        staff.post ? staff.post : selectedRow.Category_of_post_held
      );
      formData.append(
        "date_of_birth",
        staff.date_of_birth ? staff.date_of_birth : selectedRow.DOB1
      );
      formData.append(
        "category",
        staff.category ? staff.category : selectedRow.Category
      );
      formData.append(
        "gender",
        staff.gender ? staff.gender : selectedRow.Gender
      );
      formData.append(
        "father_name",
        staff.father_name ? staff.father_name : selectedRow.father_name
      );
      formData.append(
        "joining_date",
        staff.doj ? staff.doj : selectedRow.Date_of_Joining_in_the_present_post1
      );
      formData.append(
        "DDO_name",
        staff.ddo ? staff.ddo : selectedRow.Name_of_DDO
      );
      formData.append(
        "category_of_school",
        staff.category_of_school
          ? staff.category_of_school
          : selectedRow.Category_of_school
      );
      formData.append(
        "teacher_contact_no",
        staff.phone_number ? staff.phone_number : selectedRow.teacher_contact_no
      );
      formData.append(
        "hrms_id",
        staff.HRMS_id ? staff.HRMS_id : selectedRow.HRMS_ID
      );
      formData.append(
        "teacher_aadhar_card",
        staff.staff_aadhaar
          ? staff.staff_aadhaar
          : selectedRow.teacher_aadhar_card
      );
      formData.append(
        "teacher_qualification",
        staff.highest_qualification
          ? staff.highest_qualification
          : selectedRow.teacher_qualification
      );
      formData.append(
        "teacher_pan_card",
        staff.staff_pan ? staff.staff_pan : selectedRow.teacher_pan_card
      );
      formData.append(
        "teacher_photo",
        photo ? photo : selectedRow.teacher_photo
      );
      formData.append(
        "teacher_tenth_qualification",
        staff.tenth_qualification
          ? staff.tenth_qualification
          : selectedRow.tenth_qualification
      );
      formData.append(
        "teacher_twelveth_qualification",
        staff.twelveth_qualification
          ? staff.twelveth_qualification
          : selectedRow.twelveth_qualification
      );
      formData.append("id", staffid);

      updateStaff(formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            window.location.reload();
          } else {
            setIsLoading(false);
            toast.error(t(res));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseModal1 = () => {
    setModalOpen1(false);
  };

  const handleUpdateClick1 = (row) => {
    setModalOpen1(true);
  };

  const handleUpdateClick = (row) => {
    setSelectedRow(row);
    setStaffid(row.id);
    setModalOpen(true);
  };

  const getStaffDetails = () => {
    setIsLoading(true);
    getstaffinfo().then((res) => {
      if (res.status === "success") {
        console.log(res);
        setFilteredData(res.data.staff_data);
      } else {
        setRows([]);
        toast.error(t("Something went wrong"));
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    getStaffDetails();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate(`/addstaff`, { state: row });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  const formatDate = (dateStr) => {
    const parts = dateStr.split("-"); // Split the date by '-'
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Reformat to YYYY-MM-DD
    }
    return ""; // Return empty string if the date is invalid
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Staff Details")}</h5>
          <div>
            <button className="btn btn-primary btn-sm" onClick={() => view()}>
              <AddIcon />
              {t("Add Staff")}
            </button>
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Staff Name")}</TableCell>
                  <TableCell align="left">{t("HRMS ID")}</TableCell>
                  <TableCell align="left">{t("District code")}</TableCell>
                  <TableCell align="left">{t("School ID")}</TableCell>
                  <TableCell align="left">{t("Date Of Joining")}</TableCell>
                  <TableCell align="left">{t("Category Of School")}</TableCell>
                  <TableCell align="left">
                    {t("Category of post held")}
                  </TableCell>
                  <TableCell align="left">{t("Category")}</TableCell>
                  <TableCell align="left">{t("Name Of DDO")}</TableCell>
                  <TableCell align="left">{t("Gender")}</TableCell>
                  <TableCell align="left">{t("Date of Birth")}</TableCell>
                  <TableCell align="left">{t("Phone Number")}</TableCell>
                  <TableCell align="left">{t("Father Name")}</TableCell>
                  <TableCell align="left">{t("Remarks")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="left" style={{ width: "20%" }}>
                          {row.teacher_name}
                        </TableCell>
                        <TableCell align="left" style={{ width: "10%" }}>
                          {row.HRMS_ID}
                        </TableCell>
                        <TableCell align="left">{row.district_code}</TableCell>
                        <TableCell align="left">{row.school_id}</TableCell>
                        <TableCell align="left">
                          {row.Date_of_Joining_in_the_present_post}
                        </TableCell>
                        <TableCell align="left">
                          {row.Category_of_school}
                        </TableCell>
                        <TableCell align="left">
                          {row.Category_of_post_held}
                        </TableCell>
                        <TableCell align="left">{row.Category}</TableCell>
                        <TableCell align="left">{row.Name_of_DDO}</TableCell>
                        <TableCell align="left">{row.Gender}</TableCell>
                        <TableCell align="left" style={{ minWidth: "8rem" }}>
                          {row.DOB1 ? row.DOB1 : row.DOB2}
                        </TableCell>
                        <TableCell align="left">
                          {row.teacher_contact_no}
                        </TableCell>
                        <TableCell align="left">{row.father_name}</TableCell>
                        <TableCell align="left">{row.Remarks}</TableCell>
                        <TableCell align="left">
                          <BorderColorOutlinedIcon
                            style={{ color: "#4eb2e7", cursor: "pointer" }}
                            onClick={() => handleUpdateClick(row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {selectedRow && (
                <Modal
                  open={modalOpen}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 1280,
                      backgroundColor: "#ffffff",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: 8,
                      padding: 20,
                      height: 500,
                      overflowY: "scroll",
                    }}
                  >
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleCloseModal}
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background: "none",
                        border: "none",
                        fontSize: 24,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </button>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <MDBTypography tag="h5" className="">
                          {t("Update Staff Details")}
                        </MDBTypography>
                      </div>
                    </div>
                    <div className="row">
                      <form
                        onSubmit={(e) => onSubmit(e)}
                        id="myform"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Staff Photo")}
                            </label>
                            <input
                              type="file"
                              name="photo_file"
                              accept="image/*"
                              className="form-control"
                              onChange={handlePhotoChange}
                            />
                            {selectedRow.teacher_photo && (
                              <p className="text-primary">
                                {t("Selected file")}:{" "}
                                {selectedRow.teacher_photo}
                              </p>
                            )}
                            {error.photo_file && (
                              <div className="text-danger">
                                {error.photo_file}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Staff Name")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              defaultValue={
                                selectedRow ? selectedRow.teacher_name : ""
                              }
                              onChange={handleChangeInput}
                              required
                            />
                            {error.name && (
                              <div className="text-danger">{error.name}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Father Name")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="father_name"
                              defaultValue={
                                selectedRow ? selectedRow.father_name : ""
                              }
                              className="form-control"
                              onChange={handleChangeInput}
                              required
                            />
                            {error.father_name && (
                              <div className="text-danger">
                                {error.father_name}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Post")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="post"
                              className="form-control"
                              defaultValue={
                                selectedRow
                                  ? selectedRow.Category_of_post_held
                                  : ""
                              }
                              onChange={handleChangeInput}
                              required
                            />
                            {error.post && (
                              <div className="text-danger">{error.post}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Date of Birth")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="date"
                              name="date_of_birth"
                              className="form-control"
                              defaultValue={
                                selectedRow.DOB1
                                  ? formatDate(selectedRow.DOB1)
                                  : formatDate(selectedRow.DOB2)
                              }
                              onChange={handleChangeInput}
                              required
                            />
                            {error.date_of_birth && (
                              <div className="text-danger">
                                {error.date_of_birth}
                              </div>
                            )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Category")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="category"
                              defaultValue={
                                selectedRow ? selectedRow.Category : ""
                              }
                              className="form-control"
                              onChange={handleChangeInput}
                              required
                            />
                            {error.category && (
                              <div className="text-danger">
                                {error.category}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Gender")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <select
                              name="gender"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              required
                              defaultValue={
                                selectedRow ? selectedRow.Gender : ""
                              }
                            >
                              <option value="">{t("Select Gender")}</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                            {error.gender && (
                              <div className="text-danger">{error.gender}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Date Of Joining")}
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="doj"
                              onChange={handleChangeInput}
                              value={
                                selectedRow.Date_of_Joining_in_the_present_post1
                                  ? formatDate(
                                      selectedRow.Date_of_Joining_in_the_present_post1
                                    )
                                  : formatDate(
                                      selectedRow.Date_of_Joining_in_the_present_post2
                                    )
                              }
                              required
                            ></input>
                            {error.doj && (
                              <div className="text-danger">{error.doj}</div>
                            )}
                          </div>

                          <div className="col-md-4">
                            <label className="form-label">
                              {t("HRMS ID")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="hrms_id"
                              className="form-control"
                              onChange={handleChangeInput}
                              defaultValue={
                                selectedRow ? selectedRow.HRMS_ID : ""
                              }
                              required
                            />
                            {error.HRMS_id && (
                              <div className="text-danger">{error.HRMS_id}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Phone Number")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              onChange={handleChangeInput}
                              type="text"
                              pattern="[0-9]*"
                              maxLength={10}
                              minLength={10}
                              name="phone_number"
                              className="form-control"
                              defaultValue={
                                selectedRow
                                  ? selectedRow.teacher_contact_no
                                  : ""
                              }
                              required
                            />
                            {error.phone_number && (
                              <div className="text-danger">
                                {error.phone_number}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Category Of School")}{" "}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="category_of_school"
                              className="form-control"
                              onChange={handleChangeInput}
                              defaultValue={
                                selectedRow
                                  ? selectedRow.Category_of_school
                                  : ""
                              }
                              required
                            />
                            {error.category_of_school && (
                              <div className="text-danger">
                                {error.category_of_school}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Name Of DDO")}
                              {markRequired && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              name="ddo"
                              defaultValue={
                                selectedRow ? selectedRow.Name_of_DDO : ""
                              }
                              className="form-control"
                              onChange={handleChangeInput}
                              required
                            />
                            {error.ddo && (
                              <div className="text-danger">{error.ddo}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label mt-3">
                              {t("Add Documents (PDF only)")}{" "}
                            </label>
                            <div className="">
                              <button
                                type="button"
                                className="btn btn-secondary col-md-8"
                                onClick={handleUpdateClick1}
                              >
                                {t("Add")}
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="row col-12 mt-5 d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-primary mx-1 mt-4 btn-sm col-2"
                          >
                            {t("Update")}
                          </button>
                          <button
                            className="btn btn-secondary mx-1 mt-4 btn-sm col-2"
                            onClick={handleCloseModal}
                          >
                            {t("Close")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Modal>
              )}

              <Modal
                open={modalOpen1}
                onClose={handleCloseModal1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1100,
                    backgroundColor: "#ffffff",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: 8,
                    padding: 20,
                  }}
                >
                  {" "}
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModal1}
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      background: "none",
                      border: "none",
                      fontSize: 24,
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </button>
                  <div className="row mt-4 mb-2">
                    <div className="row">
                      <div className="col-6 d-flex justify-content-center">
                        <Image src={multi_img} height="300px" />
                      </div>
                      <div className="col-6">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <MDBTypography tag="h5" className="mb-4">
                              {t("Add Documents (PDF only)")}
                            </MDBTypography>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label my-3">
                              {t("Staff Aadhaar")}
                            </label>
                            <input
                              type="file"
                              name="staff_aadhaar"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {staff.staff_aadhaar && (
                              <p className="text-primary">
                                {t("Selected file")}: {staff.staff_aadhaar.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label my-3">
                              {t("Staff Pan Card")}
                            </label>
                            <input
                              type="file"
                              name="staff_pan"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {staff.staff_pan && (
                              <p className="text-primary">
                                {t("Selected file")}: {staff.staff_pan.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label my-3">
                              {t("10th Certificate")}
                            </label>
                            <input
                              type="file"
                              name="tenth_qualification"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {staff.highest_qualification && (
                              <p className="text-primary">
                                {t("Selected file")}: {staff.ten_Cert.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label my-3">
                              {t("12th Certificate")}
                            </label>
                            <input
                              type="file"
                              name="twelveth_qualification"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {staff.highest_qualification && (
                              <p className="text-primary">
                                {t("Selected file")}: {staff.twe_Cert.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label className="form-label my-3">
                              {t("Highest Qualification")}
                            </label>
                            <input
                              type="file"
                              name="highest_qualification"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {staff.highest_qualification && (
                              <p className="text-primary">
                                {t("Selected file")}:{" "}
                                {staff.highest_qualification.name}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>{t("No data available")}</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default StaffDetails;
